import { render } from "./OcMembersContent.vue?vue&type=template&id=5b16137f&scoped=true"
import script from "./OcMembersContent.vue?vue&type=script&lang=js"
export * from "./OcMembersContent.vue?vue&type=script&lang=js"

import "./OcMembersContent.vue?vue&type=style&index=0&id=5b16137f&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b16137f"]])

export default __exports__